// extracted by mini-css-extract-plugin
export default {"formRule":"src-modules-form-FormRule-style__formRule_NYitl"};